module.exports = __webpack_public_path__ + "static/media/dashIcon.211384ea.svg";